import { t } from 'i18next'
import { z } from 'zod'

import { Cpf } from '@/shared/utils/cpf'

export const IncluirCpfLeadRepresadoSchema = z.object({
  cpf: z
    .string()
    .refine((cpf) => new Cpf(cpf).validate(), t('leads-represados:pages.cadastro.validacao.cpf_invalido'))
    .transform((value) => value.replaceAll(/\D/g, '')),
})
